import type { CreateBoundaryGroupFromAIConfig } from '~/sidebar/sidebarApps/mapTools/boundary/loadBoundaryPane/createCustomBoundaryPane/createBoundaryGroupFromAIModal/createBoundaryGroupFromAIModal.types';
import { CreateOptimizedTerritoriesAdditionalOption } from '~/sidebar/sidebarApps/mapTools/boundary/loadBoundaryPane/createCustomBoundaryPane/createBoundaryGroupFromAIModal/modalSteps/additionalOptions.component';
import type { CreateOptimizedTerritoriesConfig } from './createOptimizedTerritories.types';

export const getSelectedAdditionalOption = (
  config: Partial<Pick<CreateOptimizedTerritoriesConfig, 'respectSalesLocations' | 'respectPrevTerritories' | 'useNumberOfTerritories' | 'constraintsEnabled'>
    & Pick<CreateBoundaryGroupFromAIConfig, 'respectSalesLocations' | 'respectPrevTerritories' | 'useNumberOfTerritories' | 'optimizationConstraints'>>
): CreateOptimizedTerritoriesAdditionalOption | null => {
  if (config.respectSalesLocations) {
    return CreateOptimizedTerritoriesAdditionalOption.SalesReps;
  }
  if (config.respectPrevTerritories) {
    return CreateOptimizedTerritoriesAdditionalOption.RespectPreviousTerritories;
  }
  if (config.useNumberOfTerritories) {
    return CreateOptimizedTerritoriesAdditionalOption.NumerOfTerritories;
  }
  if (config.constraintsEnabled || config.optimizationConstraints) {
    return CreateOptimizedTerritoriesAdditionalOption.Constraints;
  }
  return null;
};
